<template>
    <div id="percentage">
        <headerBg :headerBg="headerBg" class="headerBg"></headerBg>
        <div class="tage"  :style="tageBg">
            <div class="jiao">
                <div class="top_left" :style="top_left"></div>
                <div class="top_right" :style="top_right"></div>
                <div class="bottom_left" :style="bottom_left"></div>
                <div class="bottom_right" :style="bottom_right"></div>
            </div>
            <div class="txt1" :style="txt1Color">
                数据加载中......{{percentage}}%
            </div>
            <div class="progress" :style="borderSty">
                <el-progress :percentage="percentage" v-if="$route.query.type=='steam'"></el-progress>
                <el-progress :percentage="percentage" v-if="$route.query.type=='psn'"></el-progress>
                <el-progress :percentage="percentage" v-if="$route.query.type=='xbox'"></el-progress>
                <el-progress :percentage="percentage" v-if="$route.query.type=='epic'"></el-progress>
            </div>
            <div class="txt2">
                正在读取您的{{$route.query.type.toUpperCase()}}数据，这个过程可能要持续15分钟
            </div>
            
        </div>
        <footerPage class="footerPage"></footerPage>
    </div>
</template>

<script>
import footerPage from '../../components/footer.vue'
import headerBg from '../../components/headerBg.vue'
import report from "../../api/index";
export default {
    data(){
        return{
            percentage:0,
            tageBg:{},
            txt1Color:{},
           
            top_left:{},
            top_right:{},
            bottom_left:{},
            bottom_right:{},
            borderSty:{},
            headerBg:{
                height:'12.45rem',
                background: 'url('+require('../../assets/image/steam/headerBg.png')+')',
                backgroundRepeat:'no-repeat',
                backgroundSize:'300%',
                backgroundPosition: '8% 15%',
                // backgroundAttachment: 'fixed',
            },
            
        }
    },
   mounted(){
        GSAppJsApi.UMeng.recordEvent('enter_loading_page', this.$route.query.type+'年报');
        GSAppJsApi.EventStatistics.recordEvent('B19102_进入加载页面的用户数', this.$route.query.type+'年报');
        let that=this
        clearInterval(time)
    
        var time=setInterval(function(){
                that.percentage<99?that.percentage++ : 99
            },10000)
        if(that.percentage==99){
            clearInterval(time)
        }
        let data = {
            deviceType: "iPhone7,2",
            deviceId: "61BCED9D-EEE9-4F20-A197-5EF9BE079889",
            os: "iOS",
            osVersion: "12.5.5",
            app: "GSApp(iOS)",
            appVersion: "5.16.1",
            request: {
                userId: GSAppJsApi.User.getCurrentUserId()
            }
        };
        


        if(this.$route.query.type=='steam'){
            this.noDuildBg={
                 background: '#0C272E'
            }
            this.txt1Color={
                color:'#5EE6FF'
            }
            this.borderSty={
                border:' 0.05rem solid #3090A2'
            }
            document.body.style.background = "#0B1E23";
            document.getElementsByClassName('el-progress-bar__inner')[0].style.background='#5EE6FF'
            this.top_left={
                borderTop: '0.05rem solid #5EE6FF',
                borderLeft: '0.05rem solid #5EE6FF',
            }
             this.top_right={
                borderTop: '0.05rem solid #5EE6FF',
                borderRight: '0.05rem solid #5EE6FF',
            }
             this.bottom_left={
                borderBottom: '0.05rem solid #5EE6FF',
                borderRight: '0.05rem solid #5EE6FF',
            }
             this.bottom_right={
                borderBottom: '0.05rem solid #5EE6FF',
                borderLeft: '0.05rem solid #5EE6FF',
            }
            report.getSteamData(JSON.stringify(data)).then(res => {
                    if(res.errorCode==0){
                        if(res.result.reportStatus==1){
                            that.percentage=100
                            clearInterval(time1)
                            clearInterval(time)
                            
                            setTimeout(function(){
                                that.$router.push({
                                    name: "report",
                                    query:{
                                        type:'steam'
                                    }
                                });
                            },1000)
                        }else if(res.result.reportStatus==3){
                            that.$router.push({
                                name: "waitingPage",
                                query:{
                                    type:'steam'
                                }
                            });
                        }
                        
                    }
                });
            
            var time1=setInterval(function(){
                report.getSteamData(JSON.stringify(data)).then(res => {
                    if(res.errorCode==0){
                        if(res.result.reportStatus==1){
                            that.percentage=100
                            clearInterval(time1)
                            clearInterval(time)
                            
                            setTimeout(function(){
                                that.$router.push({
                                    name: "report",
                                    query:{
                                        type:'steam'
                                    }
                                });
                            },1000)
                        }else if(res.result.reportStatus==3){
                            that.$router.push({
                                name: "waitingPage",
                                query:{
                                    type:'steam'
                                }
                            });
                        }
                        
                    }
                });
            },60000)
           
        }else if(this.$route.query.type=='psn'){
            this.tageBg={
                background:'#13203F'
            }
            this.txt1Color={
                color:'#5EA6FF'
            }
            this.borderSty={
                border:' 0.05rem solid #5EA6FF'
            }
             document.body.style.background = "#0E172C";
             document.getElementsByClassName('el-progress-bar__inner')[0].style.background='#5EA6FF'
            this.top_left={
                borderTop: '0.05rem solid #5EA6FF',
                borderLeft: '0.05rem solid #5EA6FF',
            }
            this.top_right={
                borderTop: '0.05rem solid #5EA6FF',
                borderRight: '0.05rem solid #5EA6FF',
            }
             this.bottom_left={
                borderBottom: '0.05rem solid #5EA6FF',
                borderRight: '0.05rem solid #5EA6FF',
            }
             this.bottom_right={
                borderBottom: '0.05rem solid #5EA6FF',
                borderLeft: '0.05rem solid #5EA6FF',
            }
            report.getPsnData(JSON.stringify(data)).then(res => {
                    if(res.errorCode==0){
                        if(res.result.reportStatus==1){
                            that.percentage=100
                            clearInterval(time1)
                            clearInterval(time)
                            
                            setTimeout(function(){
                                that.$router.push({
                                    name: "report",
                                    query:{
                                        type:'psn'
                                    }
                                });
                            },1000)
                        }else if(res.result.reportStatus==3){
                            that.$router.push({
                                name: "waitingPage",
                                query:{
                                    type:'psn'
                                }
                            });
                        }
                        
                    }
                });
            var time1=setInterval(function(){
                report.getPsnData(JSON.stringify(data)).then(res => {
                    if(res.errorCode==0){
                        if(res.result.reportStatus==1){
                            that.percentage=100
                            clearInterval(time1)
                            clearInterval(time)
                            
                            setTimeout(function(){
                                that.$router.push({
                                    name: "report",
                                    query:{
                                        type:'psn'
                                    }
                                });
                            },1000)
                        }else if(res.result.reportStatus==3){
                            that.$router.push({
                                name: "waitingPage",
                                query:{
                                    type:'psn'
                                }
                            });
                        }
                        
                    }
                });
            },60000)
           
        }else if(this.$route.query.type=='xbox'){
             this.tageBg={
                background:'#0C2B1E'
            }
            this.txt1Color={
                color:'#5EFF97'
            }
             this.borderSty={
                border:' 0.05rem solid #5EFF97'
            }
             document.body.style.background = "#081B0F";
            document.getElementsByClassName('el-progress-bar__inner')[0].style.background='#5EFF97'
            this.top_left={
                borderTop: '0.05rem solid #5EFF97',
                borderLeft: '0.05rem solid #5EFF97',
            }
            this.top_right={
                borderTop: '0.05rem solid #5EFF97',
                borderRight: '0.05rem solid #5EFF97',
            }
             this.bottom_left={
                borderBottom: '0.05rem solid #5EFF97',
                borderRight: '0.05rem solid #5EFF97',
            }
             this.bottom_right={
                borderBottom: '0.05rem solid #5EFF97',
                borderLeft: '0.05rem solid #5EFF97',
            }
            report.getXboxData(JSON.stringify(data)).then(res => {
                    if(res.errorCode==0){
                        if(res.result.reportStatus==1){
                            that.percentage=100
                            clearInterval(time1)
                            clearInterval(time)
                            setTimeout(function(){
                                that.$router.push({
                                    name: "report",
                                    query:{
                                        type:'xbox'
                                    }
                                });
                            },1000)
                        }else if(res.result.reportStatus==3){
                            that.$router.push({
                                name: "waitingPage",
                                query:{
                                    type:'xbox'
                                }
                            });
                        }
                        
                    }
                });
            
            var time1=setInterval(function(){
                report.getXboxData(JSON.stringify(data)).then(res => {
                    if(res.errorCode==0){
                        if(res.result.reportStatus==1){
                            that.percentage=100
                            clearInterval(time1)
                            clearInterval(time)
                            setTimeout(function(){
                                that.$router.push({
                                    name: "report",
                                    query:{
                                        type:'xbox'
                                    }
                                });
                            },1000)
                        }else if(res.result.reportStatus==3){
                            that.$router.push({
                                name: "waitingPage",
                                query:{
                                    type:'xbox'
                                }
                            });
                        }
                        
                    }
                });
            },60000)
        }else if(this.$route.query.type=='epic'){
            var time1=setInterval(function(){
                that.$ajax.get('http://router.gamersky.com/@/epic/reportData/'+GSAppJsApi.User.getCurrentUserId()).then(res=>{
    
                    if(res.data.reportStatus==1){
                        that.percentage=100
                        clearInterval(time1)
                        clearInterval(time)
                        setTimeout(function(){
                            that.$router.push({
                                name: "report",
                                query:{
                                    type:'epic'
                                }
                            });
                        },1000)
                    }else if(res.data.reportStatus==3){
                        that.$router.push({
                            name: "waitingPage",
                            query:{
                                type:'epic'
                            }
                        });
                    }
                })
            },60000)
            this.tageBg={
                background:'#191919'
            }
            this.txt1Color={
                color:'#FF5E5E'
            }
            this.borderSty={
                border:' 0.05rem solid #FF5E5E'
            }
             document.body.style.background = "#141414";
            document.getElementsByClassName('el-progress-bar__inner')[0].style.background='#FF5E5E'
            this.top_left={
                borderTop: '0.05rem solid #FF5E5E',
                borderLeft: '0.05rem solid #FF5E5E',
            }
            this.top_right={
                borderTop: '0.05rem solid #FF5E5E',
                borderRight: '0.05rem solid #FF5E5E',
            }
             this.bottom_left={
                borderBottom: '0.05rem solid #FF5E5E',
                borderRight: '0.05rem solid #FF5E5E',
            }
             this.bottom_right={
                borderBottom: '0.05rem solid #FF5E5E',
                borderLeft: '0.05rem solid #FF5E5E',
            }
            
        }
   },
   components:{
        footerPage,
        headerBg
   }
}
</script>

<style>
#percentage{
    padding: 13.6rem 1.8rem 15.1rem;
}
#percentage .headerBg{
    position: fixed;
    top: 0;
    left: 0;
}
#percentage .jiao{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
#percentage .jiao>div{
    position: absolute;
    width: 1.4rem;
    height: 1.4rem;
   
}
#percentage .top_left{
    top: 0.5rem;
    left: 0.5rem;
}
#percentage .top_right{
    top: 0.5rem;
    right: 0.5rem;
}
#percentage .bottom_right{
    bottom: 0.5rem;
    left: 0.5rem;
}
#percentage .bottom_left{
    bottom: 0.5rem;
    right: 0.5rem;
}
#percentage .tage{
    width: 15.95rem;
    height: 10.75rem;
    background: #0C272E;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
}
#percentage .progress{
  
    border-radius: 0.35rem;
    padding: 0 0.15rem;
    margin: 0.75rem 0;
    height: 0.6rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
#percentage .txt1{
    font-size: 1.05rem;
    font-family: AlibabaPuHuiTiBold;
    color: #5EE6FF;
   
}
#percentage .txt2{
    font-size: 0.4rem;
    font-family: Source Han Sans CN;
    color: rgba(255, 255, 255, 0.4);
   
}

#percentage .el-progress{
    width: 13.15rem;
    display: flex;
}
#percentage .el-progress__text{
    display: none;
}
#percentage .steam .el-progress-bar__inner{
    background-color: #3090A2;
}

#percentage .el-progress-bar__outer{
    background-color: rgba(48, 144, 162, 0.1);
}
#percentage .percentage{
    border: 0.05rem solid #3090A2;
    border-radius: 0.35rempx;
}
#percentage .el-progress-bar{
    padding-right: 0;
}



</style>